module.exports = __webpack_public_path__ + "static/media/minus_sign.714a9cf6.svg";